class CalculusUtils {
  static simpleReducer(arr) { 
    return arr.reduce((prev, current) => Number(prev) + Number(current))
  }
  static sumObjectProps(arr, field) {
    return arr.reduce((previousValue, currentValue) => previousValue + currentValue[field], 0);
  }
  static sumObjectPropsByNotZero(arr, fieldToBeAdded, fieldAsCondition){
    return arr.reduce((previousValue, currentValue) => previousValue + (currentValue[fieldAsCondition] > 0 ? currentValue[fieldToBeAdded] : 0 ), 0);
  }
  static sumObjectPropsByThreshold(arr, fieldToBeAdded, fieldAsCondition, threshold){
    return arr.reduce((previousValue, currentValue) => previousValue + (currentValue[fieldToBeAdded] > threshold && currentValue[fieldAsCondition] > 0 ? currentValue[fieldToBeAdded] : 0 ), 0);
  }
}

export {
    CalculusUtils,
}